export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 45C10.85 45 1 35.15 1 23S10.85 1 23 1\" fill=\"#002395\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 1h16v44H15V1z\" fill=\"#fff\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.013 3A22.022 22.022 0 0145 23.488 22.022 22.022 0 0131.048 44c-.116-5.943.023-35.74-.035-41z\" fill=\"#ED2939\"/>",
  "attrs": {
    "width": "46",
    "height": "46",
    "viewBox": "0 0 46 46",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};